import actionCreator from "helpers/actionCreator"
import {
  createDetailActions,
  handleSetSortOrder,
  handleSetGroupSortOrder,
  handleShowContributorCategory,
  handleHideContributorCategory,
  handleShowGroup,
  handleHideGroup,
  handleGroupSort,
} from "helpers/compositeSecuritiesDetails"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeCompositePerformanceDetails", {
  ...createDetailActions("performance"),
}, { track: true })

export const queryStringReducers = {
  [Types.SET_SORT_ORDER]: handleSetSortOrder,
  [Types.SET_GROUP_SORT_ORDER]: handleSetGroupSortOrder,
  [Types.SHOW_GROUP]: handleShowGroup,
  [Types.HIDE_GROUP]: handleHideGroup,
  [Types.GROUP_SORT]: handleGroupSort,
  [Types.SHOW_CONTRIBUTOR_CATEGORY]: handleShowContributorCategory,
  [Types.HIDE_CONTRIBUTOR_CATEGORY]: handleHideContributorCategory,
}
